import React from 'react';
import {Redirect, Route} from 'react-router';
import {authenticateService} from "../../lib/services/http";

export const AuthorizedRoute = (props) => {
    const auth = new authenticateService();
    const route = <Route exact={props.exact} path={props.path} component={props.component} />;
    const redirect = <Redirect  to={"/login"} />;
    return(auth.isLoggedIn() ? route : redirect);
};